import React from 'react';
import * as PropTypes from 'prop-types';
import { Groove, Slider } from './elements';

function Swi01(props) {
  return (
    <Groove
      className={props.className}
      checked={props.checked}
      theme={props.theme}
    >
      <input
        disabled={props.disabled}
        checked={props.checked}
        onChange={props.onChange}
        type="checkbox"
      />
      <Slider checked={props.checked} theme={props.theme} />
    </Groove>
  );
}

Swi01.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  theme: PropTypes.bool,
};
export default Swi01;
